import React from 'react';
import './CustomerOrderModal.scss';
import IconItem from '../../../../../../components/Item/IconItem/IconItem';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setOpenProformaAutomotorModal, setCloseModal } from 'store/slices/proformaAutomotorModal.slice';


type Props = {
  setOpenModal: (e: boolean) => void;
  setStepModal: (e: string) => void;
};

const CustomerOrderModal: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setCloseModal(true));
    props.setOpenModal(false);
  };

  const handleReplaceFile = () => {
    dispatch(setOpenProformaAutomotorModal(true));
    dispatch(setCloseModal(true));
    props.setOpenModal(false);

  };

  return (
    <div className="customer-order-modal" >
      <div className="close upload_order_info_line_close">
        <IconItem icon={faClose} onClick={() => { props.setOpenModal(false); }} />
      </div>
      <div className="customer-modal-body">
        <div className="customer-modal-row">
          <div className="customer-modal-title">{t('_your_file_has_been_uploaded_successfully')}</div>
          <div className="customer-modal-subtitle">
            <Trans
              i18nKey="_number_of_lines_detected"
              components={{ bold: <strong /> }}
              values={{ number: proformaFile?.count.toLocaleString('fr-FR') || 0 }}
            /></div>
        </div>
        <div className="customer-modal-row">
          <div className="customer-modal-button">
            <DefaultButton className="customer-modal-btn upload_order_info_line" text={t('_send_the_order_for_processing')} onClick={() => { props.setStepModal('ValidationReferencesDuplicateDetected'); }} />
            <DefaultButton className="customer-modal-btn upload_order_info_line_replace_existing_file" text={t('_replace_existing_file')} onClick={() => { handleReplaceFile(); }} />
            <DefaultButton className="customer-modal-btn cancel upload_order_info_line_cancel" text={t('_cancel')} onClick={() => { handleClose(); }} />

          </div>

        </div>

      </div>

    </div>
  );
};

export default CustomerOrderModal;